import { NgModule } from '@angular/core';
import { BodyModule, GridModule, SharedModule } from '@progress/kendo-angular-grid';
import { KendoFilterComponentModule } from '@kimaya/kendo-filters-lib';

const COMPONENTS_EXPORT = [];
const COMPONENTS_ENTRY = [];
const COMPONENTS = [...COMPONENTS_EXPORT, ...COMPONENTS_ENTRY];

const MODULES_EXPORT = [
  GridModule,
  BodyModule,
  SharedModule,
  KendoFilterComponentModule,
];
const MODULES = [...MODULES_EXPORT];

@NgModule({
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS_ENTRY],
  imports: [...MODULES],
  exports: [...MODULES_EXPORT, ...COMPONENTS_EXPORT]
})
export class ShareKendoModule {
}
